import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import logger from '@lib/util/shared/logger';
const getConfigMessages = async locale => {
  const configName = process.env.NEXT_PUBLIC_APP_CONFIG;
  try {
    return (await import("../config/messages/".concat(configName, "/").concat(locale, ".json"))).default;
  } catch (error) {
    // Fallback to default messages if config-specific messages don't exist
    console.log('error', error);
    try {
      return (await import("../config/messages/default.json")).default;
    } catch {
      return {};
    }
  }
};
const getMessages = async locale => {
  try {
    const baseMessages = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (await import("./shared/".concat(locale, ".json"))).default), (await import("./flights/".concat(locale, ".json"))).default), (await import("./retail/".concat(locale, ".json"))).default), (await import("./cars/".concat(locale, ".json"))).default), (await import("./insurances/".concat(locale, ".json"))).default), (await import("./hotels/".concat(locale, ".json"))).default), (await import("./demos/".concat(locale, ".json"))).default), (await import("./promo/".concat(locale, ".json"))).default);

    // Get config-specific overrides
    const configOverrides = await getConfigMessages(locale);
    // Merge base messages with config-specific overrides
    const finalMessages = _.merge({}, baseMessages, configOverrides);
    return finalMessages;
  } catch (error) {
    // Prefer centralized logger
    // logger.error will format and respect log level thresholds
    logger.error("\u274C Error loading messages for locale ".concat(locale, ":"), error);
    // Fallback to English if there's an error
    if (locale !== 'en') {
      // This is informational but keep it via logger for parity
      logger.error("\uD83D\uDD04 Falling back to English messages");
      return getMessages('en');
    }
    return {};
  }
};
export default getMessages;